<template>
  <div class="cascader-prop">
    <FormItem label="默认值">
      <Input
        :value="info.defaultValue.join(',')"
        readonly
        placeholder="默认值"
        :disabled="!info.isNew"></Input>
    </FormItem>
    <FormItem label="占位提示">
      <Input v-model="info.form.placeholder" placeholder="请输入占位提示"></Input>
    </FormItem>
    <FormItem label="是否清空">
      <i-switch v-model="info.form.clearable" />
    </FormItem>
    <FormItem label="是否搜索">
      <i-switch v-model="info.form.filterable" />
    </FormItem>
  </div>
</template>
<script>
export default {
  name: 'CascaderProp',
  props: {
    info: Object,
  },
}
</script>